import { OrdersApi } from '@/gen/ecom/apis'
import { ecomConfiguration } from '@/lib/clients/apiConfigs'

export const ordersClient = new OrdersApi(ecomConfiguration)
